import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

import { Container, Title, Description } from './noResults.styles';

export const NoResults = ({ className, titleMessage, descriptionMessage }) => {
  return (
    <Container className={className}>
      <Title>
        <FormattedMessage {...titleMessage} />
      </Title>
      <Description>
        <FormattedHTMLMessage {...descriptionMessage} />
      </Description>
    </Container>
  );
};

NoResults.propTypes = {
  className: PropTypes.string,
  titleMessage: PropTypes.object.isRequired,
  descriptionMessage: PropTypes.object.isRequired,
};
